<div class="modal-header">
    <h4 class="modal-title" translate="services.publicLighting.light.detail"></h4>

    <button class="btn-close" aria-label="Close"
            (click)="this.activeModal.close('close')">
    </button>
</div>

@if (isLoaded) {
    <div class="modal-body custom-layout">
        <form>
            <!-- Last data update date -->
            <div class="row">
                <div class="col-6">
                    <label class="form-label">{{ 'publicLighting.light.modal.lastDataUpdate' | translate }}</label>
                </div>
                <div class="col-6 text-end">
                    <p class="form-label">{{ light.lastDataUpdate | date:dateTimeFormat }}</p>
                </div>
            </div>

            <h6 translate="publicLighting.light.modal.providerInformationsTitle"></h6>
            <!-- Provider information -->
            @if (light.lightProvider && light.externalId) {
                @if (light.externalStatus === PublicLightingExternalStatus.NotAvailable) {
                    <div class="row">
                        <div>
                            <p class="form-label text-error">
                                {{ 'publicLighting.light.modal.lightNotAvailable' | translate: {id: light.externalId} }}</p>
                        </div>
                    </div>
                } @else if (light.externalStatus === PublicLightingExternalStatus.NotExisting) {
                    <div class="row">
                        <div>
                            <p class="form-label text-error">
                                {{ 'publicLighting.light.modal.lightNotExisting' | translate: {id: light.externalId} }}</p>
                        </div>
                    </div>
                }

                <div class="row">
                    <div class="col-6">
                        <label class="form-label">{{ 'publicLighting.light.modal.name' | translate }}</label>
                    </div>
                    <div class="col-6 text-end">
                        <p class="form-label">{{ light.lightProvider }}</p>
                    </div>
                </div>

                @if (light.externalStatus === PublicLightingExternalStatus.Available) {
                    <div class="row">
                        <div class="col-6">
                            <label class="form-label">{{ 'publicLighting.light.modal.lightId' | translate }}</label>
                        </div>
                        <div class="col-6 text-end">
                            <p class="form-label">{{ light.externalName }}</p>
                        </div>
                    </div>
                }
            } @else {
                <div class="row">
                    <div>
                        <label class="form-label">{{ 'publicLighting.light.modal.lightNotLinked' | translate }}</label>
                    </div>
                </div>
            }

            <h6 translate="publicLighting.light.modal.lightInformationsTitle"></h6>
            <!-- Light information -->
            <div class="row">
                <div class="col-6">
                    <label class="form-label">{{ 'publicLighting.light.modal.code' | translate }}</label>
                </div>
                <div class="col-6 text-end">
                    <p class="form-label">{{ light.code }}</p>
                </div>
            </div>

            <div class="row">
                <div class="col-6">
                    <label class="form-label">{{ 'publicLighting.light.modal.description' | translate }}</label>
                </div>
                <div class="col-6 text-end">
                    <p class="form-label">{{ light['description' + crtLang.toUpperCase()] }}</p>
                </div>
            </div>

            <div class="row">
                <div class="col-6">
                    <label class="form-label">{{ 'publicLighting.light.modal.zoneCode' | translate }}</label>
                </div>
                <div class="col-6 text-end">
                    <p class="form-label">{{ light.lightZoneCode }}</p>
                </div>
            </div>

            <div class="row">
                <div class="col-6">
                    <label class="form-label">{{ 'publicLighting.light.modal.position' | translate }}</label>
                </div>
                <div class="col-6 text-end">
                    @if (light.externalCoordinates) {
                        <p class="form-label">
                            {{ light.externalCoordinates }}</p>
                    } @else {
                        <p class="form-label">--</p>
                    }
                </div>
            </div>

            <div class="row">
                <div class="col-6">
                    <label class="form-label">{{ 'publicLighting.light.modal.consumption' | translate }}</label>
                </div>
                <div class="col-6 text-end">
                    @if (light.totalConsumption) {
                        <p class="form-label">
                            {{ light.totalConsumption.toFixed(2) }}</p>
                    } @else {
                        <p class="form-label">--</p>
                    }
                </div>
            </div>

            <div class="row">
                <div class="col-6">
                    <label class="form-label">{{ 'publicLighting.light.modal.intensity' | translate }}</label>
                </div>
                <div class="col-6 text-end">
                    @if (light.intensity || light.intensity === 0) {
                        <p class="form-label">
                            {{ light.intensity }} %</p>
                    } @else {
                        <p class="form-label">--</p>
                    }
                </div>
            </div>

            <div class="row">
                <div class="col-6">
                    <label class="form-label">{{ 'publicLighting.light.modal.state' | translate }}</label>
                </div>
                <div class="col-6 text-end">
                    @if (light.publicLightingState) {
                        @if (light.publicLightingState === PublicLightingState.Connected) {
                            <p class="form-label">
                                {{ 'publicLighting.light.state.connected' | translate }}</p>
                        }
                        @if (light.publicLightingState === PublicLightingState.Disconnected) {
                            <p class="form-label">
                                {{ 'publicLighting.light.state.disconnected' | translate }}</p>
                        }
                        @if (light.publicLightingState === PublicLightingState.Unknown) {
                            <p class="form-label">
                                {{ 'publicLighting.light.state.unknown' | translate }}</p>
                        }
                    } @else {
                        <p class="form-label">--</p>
                    }
                </div>
            </div>
        </form>
    </div>
}

<div class="modal-footer flex-end">
    @if (light && light.alarmId) {
        <button class="btn btn-outline-danger"
                (click)="goToTechnicalAlarmDetails()"
                translate="publicLighting.light.modal.alarm">
        </button>
    }
</div>


